import { render, staticRenderFns } from "./HtOrgTree.vue?vue&type=template&id=1b247d24&scoped=true&"
import script from "./HtOrgTree.vue?vue&type=script&lang=js&"
export * from "./HtOrgTree.vue?vue&type=script&lang=js&"
import style0 from "./HtOrgTree.vue?vue&type=style&index=0&id=1b247d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b247d24",
  null
  
)

export default component.exports